import { render } from "./taoquKnighthood.vue?vue&type=template&id=a2066f00&scoped=true&ts=true"
import script from "./taoquKnighthood.vue?vue&type=script&lang=ts"
export * from "./taoquKnighthood.vue?vue&type=script&lang=ts"

import "./taoquKnighthood.vue?vue&type=style&index=0&id=a2066f00&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2066f00"]])

export default __exports__